import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("product", ["product"]),
    options() {
      return [
        {
          icon: "ph-bold ph-list-dashes",
          title: "Informações básicas",
          subtitle: "Escolha o tipo do produto e informações básicas",
          route: "product-basic-info",
          color: "purple"
        },
        {
          icon: "ph-fill ph-handshake",
          title: "Coprodutores",
          subtitle: "Compartilhe o produto com seus coprodutores",
          route: "product-coproducers",
          color: "purple"
        },

        {
          icon: "ph ph-qr-code",
          title: "Fazer check-in",
          subtitle:
            "Faça o check-in dos seus participantes através da leitura do QR Code",
          modal: "checkin",
          type_product: ["onsite_event"],
          permissions: ["gerenciar-participantes"],
          color: "blue"
        },
        {
          icon: "ph-fill ph-ticket",
          title: "Ingressos",
          subtitle: "Visualize e configure os ingressos do seu evento",
          route: "event-lots",
          type_product: ["onsite_event"],
          color: "blue"
        },
        {
          icon: "ph-fill ph-users-four",
          title: "Participantes",
          subtitle: "Lista de participantes e controle de check-in",
          route: "event-participants",
          type_product: ["onsite_event"],
          permissions: ["gerenciar-participantes"],
          color: "blue"
        },

        {
          icon: "ph-fill ph-shopping-bag",
          title: "Configurar Checkout",
          subtitle: "Configure as informações do seu checkout",
          route: "config-checkout",
          permissions: ["configurar-checkout"],
          color: "green"
        },
        {
          icon: "ph-fill ph-magic-wand",
          title: "Personalizar Checkout",
          subtitle:
            "Defina como vai ser a cara do seu checkout, para melhor atender seu clientes",
          route: "product-customize-checkout",
          permissions: ["configurar-checkout"],
          color: "green"
        },
        {
          icon: "ph-fill ph-link",
          title: "Links de Divulgação",
          subtitle: "Veja os links gerados para divulgação do seu produto",
          route: "product-links",
          color: "green"
        },
        {
          icon: "ph-fill ph-currency-dollar-simple",
          title: "Precificação e Ofertas",
          subtitle: "Configure os preços e ofertas de venda do seu produto",
          route: "product-prices",
          permissions: ["gerenciar-ofertas"],
          type_product: ["online_course"],
          color: "green"
        },
        {
          icon: "ph-fill ph-currency-dollar-simple",
          title: "Precificação e Planos",
          subtitle: "Configure os preços e planos de venda do seu produto",
          route: "product-plans",
          permissions: ["gerenciar-ofertas"],
          type_product: ["signature"],
          color: "green"
        },
        {
          icon: "ph-fill ph-receipt",
          title: "Cupons de desconto",
          subtitle:
            "Visualize e configure os cupons de desconto do seu produto",
          route: "product-coupons",
          permissions: ["gerenciar-ofertas"],
          type_product: ["online_course"],
          color: "green"
        },
        {
          icon: "ph-fill ph-funnel",
          title: "Funil de vendas",
          subtitle: "Ofereça um novo produto após a primeira compra",
          route: "product-upsell",
          type_product: ["online_course", "signature"],
          color: "green"
        },
        {
          icon: "ph-fill ph-cursor",
          title: "Link one click buy",
          subtitle:
            "Ofereça um produto após a primeira compra, usando um link one click buy",
          route: "product-oneclickbuy",
          color: "green"
        },
        {
          icon: "ph-fill ph-target",
          title: "Pixel de rastreamento",
          subtitle: "Monitore o comportamento dos seus compradores e anúncios",
          route: "product-edit-pixel",
          color: "green"
        },
        {
          icon: "ph-fill ph-chart-line-up",
          title: "Api de conversões",
          subtitle:
            "Otimize suas campanhas e anúncios com informações sobre o comportamento de seu cliente",
          route: "product-analytics",
          color: "green"
        },

        {
          icon: "ph-fill ph-paint-bucket",
          title: "Configurar área de Membros",
          subtitle:
            "Configure o layout da sua área de membros, Certificado, Suporte e FAQ",
          route: "product-member-area-setup",
          type_product: ["online_course", "signature"],
          color: "blue"
        },
        {
          icon: "ph-fill ph-book-bookmark",
          title: "Conteúdo",
          subtitle:
            "Adicione e organize o conteúdo que será disponibilizado para seus clientes",
          route: "product-member-area-modules",
          type_product: ["online_course", "signature"],
          color: "blue"
        },
        {
          icon: "ph-fill ph-tag",
          title: "Categorias",
          subtitle:
            "Personalize uma categoria para agrupar os módulos de um mesmo tópico",
          route: "product-member-area-categories",
          type_product: ["online_course", "signature"],
          color: "blue"
        },
        {
          icon: "ph-fill ph-student",
          title: "Alunos",
          subtitle: "Adicione e acompanhe o progresso dos seus alunos",
          route: "product-member-area-students",
          type_product: ["online_course", "signature"],
          status: ["active"],
          color: "blue"
        },
        {
          icon: "ph-fill ph-users-four",
          title: "Turmas",
          subtitle: "Organize seus alunos em turmas",
          route: "product-member-area-groups",
          type_product: ["online_course", "signature"],
          status: ["active"],
          color: "blue"
        },
        {
          icon: "ph-fill ph-chat-circle-text",
          title: "Comentários",
          subtitle: "Visualize os comentários da sua área de membros",
          route: "product-member-area-comments",
          type_product: ["online_course", "signature"],
          status: ["active"],
          color: "blue"
        }
      ].filter(opt => {
        if (
          opt.type_product &&
          !opt.type_product.includes(this.product.type_product)
        )
          return false;

        if (
          opt.permissions &&
          opt.permissions.find(p => !this.$permissions.hasPermission(p))
        )
          return false;

        if (opt.status && !opt.status.includes(this.product.status))
          return false;

        return true;
      });
    }
  }
};
